export default(function(value){return value.length===0;});